import decode from 'jwt-decode';
import BaseService from "../core/BaseService";

const isTokenExpired = (token: string) => {
  try {
    const { exp } = decode<{ exp?: number }>(token);
    // Tokens issued before expiry was added carry no exp; treat them as expired.
    if (typeof exp !== 'number') return true;
    return exp < Date.now() / 1000;
  } catch (err) {
    return true;
  }
}

export default class AuthService extends BaseService {
  
  static async login(username: string, password: string) {
    const result = await super.request(`/auth/login`, 'POST', { username, password });
    localStorage.setItem('user', JSON.stringify(result));
    return result;
  }

  static checkToken() {
    const tokenStr = localStorage.getItem('user');
    const obj = tokenStr ? JSON.parse(tokenStr)||{} : {};
    return { isLoggedIn: !!obj.token && !isTokenExpired(obj.token), user: obj.user };
  }

  static logout () { 
    localStorage.removeItem('user');
  }

  static getClientSlug() {
    const userInStorage = localStorage.getItem('user');
    const user = userInStorage ? JSON.parse(userInStorage) : null;

    return user && user.user ? user.user.slug : '';
  }

}